import { useEffect, useState } from 'react';
import { useKeyPressNavigation } from '../../_utils';
import { createBaseSelect, } from '../base-select';
import { useSelect } from '../select-util';
export const Menu = (props) => {
    const { optionsGroups, selectedOptions, onChange, multiSelect, onKeyPressCB, menuRef, selectHeaderRef, onSearchInput, ...restProps } = props;
    const type = 'menu';
    const { visible, setSearchTerm, optionsResults } = useSelect(true, optionsGroups, onSearchInput);
    // eslint-disable-next-line no-extra-boolean-cast
    const [currentSelectedOptions, setSelectedOptions] = useState(selectedOptions || []);
    const flattenedOptions = optionsGroups.reduce((acc, currentvalue) => [...acc, ...currentvalue.options], []);
    /** To get return the selected options on change if
     * multiSelect option is true
     */
    const getSelectedOptionsonChange = (filteredOptions) => {
        const optionsKeyValue = new Map();
        flattenedOptions.forEach((option) => optionsKeyValue.set(option.id, option));
        const resultSelectedOptions = [];
        filteredOptions.forEach((key) => resultSelectedOptions.push(optionsKeyValue.get(key)));
        return resultSelectedOptions;
    };
    const onSelectCallback = (item) => {
        if (item) {
            const { id } = item;
            let filteredOptions;
            if (currentSelectedOptions.indexOf(id) >= 0) {
                filteredOptions = currentSelectedOptions.filter((option) => option !== id);
                setSelectedOptions([...filteredOptions]);
            }
            else {
                filteredOptions = [...currentSelectedOptions, id];
                setSelectedOptions(filteredOptions);
            }
            if (multiSelect && onChange) {
                onChange(getSelectedOptionsonChange(filteredOptions));
            }
            if (!multiSelect && onChange) {
                onChange(item);
            }
            setSearchTerm('');
        }
    };
    const { cursor } = useKeyPressNavigation(document, flattenedOptions, onSelectCallback, visible);
    const menuProps = {
        type,
        isMenuVisible: true,
        optionsGroups: optionsResults,
        selectedOptions: currentSelectedOptions,
        multiSelect,
        onKeyPressCB,
        ...restProps,
    };
    useEffect(() => {
        var _a;
        if (cursor >= 0 && !!flattenedOptions[cursor]) {
            // this way all menu items will be accessed for screenreader even for those having id as number
            const ele = (_a = menuRef === null || menuRef === void 0 ? void 0 : menuRef.current) === null || _a === void 0 ? void 0 : _a.querySelector(`[id="${flattenedOptions[cursor].id}"]`);
            ele === null || ele === void 0 ? void 0 : ele.focus();
        }
    }, [cursor, menuRef, flattenedOptions]);
    return createBaseSelect(menuProps, {
        setSearchTerm,
        onSelectCallback,
        dropDownHeader: null,
        dropDownHeaderRef: selectHeaderRef,
        optionHighlighted: flattenedOptions[cursor] === undefined
            ? null
            : flattenedOptions[cursor],
    });
};
//# sourceMappingURL=select-menu.js.map